import React, { Fragment, useEffect } from "react";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchDeleteLevel } from "../actions/level";
import { fetchLevelList } from "../actions/level";
import { statusRender } from "../utils/cellRenderTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const LevelList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "leveling";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { levelList } = useSelector((state) => state.levelReducer);

  useEffect(() => {
    dispatch(fetchLevelList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/level-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const imageRenderer = (params) => {
    if (!params.data || !params.data.badge || !params.data.name) return null;
    return (
      <img
        src={params.data.badge}
        alt={params.data.name}
        className="image-aggrid-cell"
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteLevel(pageId));
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("levelList.badge"),
      field: "badge",
      width: 130,
      cellRenderer: imageRenderer,
    },
    {
      headerName: t("levelList.name"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("levelList.points"),
      field: "points",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 150,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("levelList.createdAt"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("levelList.updatedAt"),
      field: "updatedAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={levelList}
        columnDefs={columnDefs}
        rowHeight={80}
        buttonLink={`/level-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"level-list"}
      />
    </Fragment>
  );
};

export default LevelList;
